<template>
  <div id="buyMembershipPackageDetailPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="جزئیات پکیج"></ActionBar>
    <div v-if="isLoaded" class="row container mx-auto p-0  mt-2">
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mx-auto bg-white round12px">
        <v-img v-if="packageDetail.FileUrl !== null" :src="$replaceHttps(packageDetail.FileUrl)"></v-img>
        <div class="dark-blue-text font16px my-2 text-center font-weight-bold">{{ packageDetail.Name }}</div>
        <div class=" font20px">
          {{ $computingPriceOffer(packageDetail.Price, packageDetail.Discount) }}
        </div>

        <div :class="packageDetail.Discount !== 0 ?  true: 'hide-visibility'" class="font-12 hidden-visibility-height" >
          <div class=" mr-3" v-bind:class="checkOffPrice(packageDetail.Discount)">
            {{ $numberWithCommas(packageDetail.Price) }}
            <span v-if="packageDetail.Price !== 0" class="pl-1" v-bind:class="checkOffPrice(packageDetail.Discount)">تومان</span>
          </div>
        </div>
        <div class=" my-4">تعداد روز فعال: {{ packageDetail.ActiveDay }}</div>
        <div class="my-4">{{ packageDetail.Description }}</div>
        <div class="text-left">
          <v-btn color="primary" rounded @click="buyPackage(packageDetail.PackageID)">
            خرید پکیج
          </v-btn>
        </div>
      </div>
    </div>
    <FooterMenu :currentPage="'signUp'"/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        persistent
        hide-overlay
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "BuyMembershipPackageDetail",
  metaInfo: {
    title: 'مسیربرتر-جزئیات پکیج'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    packageDetail: null,
    showLoaderDialog: false,
    isLoaded: false,
    showResultDialog: false,
    dialogResult: null,
    paymentHistory: []

  }),
  mounted() {
    _this = this;
    this.showLoaderDialog = true;
    this.getData()
    this.getHistory()
  },
  methods: {
    getHistory() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let now = this.$convertDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

      let date = new Date()
      date.setFullYear(date.getFullYear() - 1)
      let yearAgo = this.$convertDate(new Date(date - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))

      let urlencoded = new URLSearchParams();

      urlencoded.append("AppUserID", this.$getUserData().userID);
      urlencoded.append("StartDate", yearAgo);

      urlencoded.append("EndDate", now);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageReportManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            json.sort(function (a, b) {
              return new Date(b.ModifiedDate) - new Date(a.ModifiedDate);
            });
            _this.paymentHistory = json.filter(x => x.IsExpire === false)
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(this.$baseUrl + "PackageManagement/SpecialPackage?PackageID=" + _this.$route.query.PackageID, requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.packageDetail = JSON.parse(result)
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    buyPackage(id) {
      this.showLoaderDialog = true
      let history = this.paymentHistory
      let findBuy =history.filter(x => x.PackageID === id)
      if (findBuy.length >0) {
        this.showLoaderDialog = false
        _this.showResultDialog = true;
        _this.dialogResult = 'این پکیج را قبلا خریداری کرده اید'
      } else {

        let myHeaders = new Headers();
        myHeaders.append("Authorization", _this.$getUserData().token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("PackageID", id);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "PackageManagement/BuyOnline", requestOptions)
            .then(response => response.text())
            .then(result => {
              _this.showLoaderDialog = false;
              if (_this.packageDetail.Price === 0) {
                _this.showResultDialog = true;
                _this.dialogResult = result
              } else {
                _this.$openLink(result)
              }
            })
            .catch(error => console.log('error', error));
      }
    },
    checkOffPrice(offPrice) {
      if (offPrice !== 0) {
        return 'price';
      }
    },
  }
}
</script>

